import { createApp } from 'vue'
import App from './App.vue'
import router from './Router.js'
import { state, stateKeys } from './store/states';

createApp(App).provide(stateKeys, state()).use(router).mount('#app')
